/**
 * Colour scheme tokens for the Horoscope PDF export.
 * Each scheme provides a complete palette consumed by HoroscopePdfDocument.
 *
 * @module pdfColorSchemes
 * @see HoroscopePdfDocument
 */

export const colorSchemes = {
  light: {
    background: '#FFFFFF',
    text: '#1A1A1A',
    headerBg: '#F5F5F5',
    headerText: '#333333',
    tableBorder: '#CCCCCC',
    tableHeaderBg: '#E8E8E8',
    tableHeaderText: '#333333',
    tableRowAlt: '#F9F9F9',
    accentColor: '#B8860B',
    mutedText: '#777777',
    yogaStrong: '#2E7D32',
    yogaModerate: '#F57F17',
    yogaWeak: '#C62828',
    doshaPresent: '#C62828',
    doshaAbsent: '#2E7D32',
  },
  dark: {
    background: '#1A1A2E',
    text: '#E0E0E0',
    headerBg: '#16213E',
    headerText: '#E0E0E0',
    tableBorder: '#2C3E6B',
    tableHeaderBg: '#0F3460',
    tableHeaderText: '#E0E0E0',
    tableRowAlt: '#1E1E3A',
    accentColor: '#E94560',
    mutedText: '#9E9E9E',
    yogaStrong: '#66BB6A',
    yogaModerate: '#FFD54F',
    yogaWeak: '#EF5350',
    doshaPresent: '#EF5350',
    doshaAbsent: '#66BB6A',
  },
  saffron: {
    background: '#FFF8F0',
    text: '#4A2C0A',
    headerBg: '#FFE4C4',
    headerText: '#8B4513',
    tableBorder: '#DEB887',
    tableHeaderBg: '#FFDEAD',
    tableHeaderText: '#8B4513',
    tableRowAlt: '#FFF5E6',
    accentColor: '#D2691E',
    mutedText: '#A0784C',
    yogaStrong: '#2E7D32',
    yogaModerate: '#E65100',
    yogaWeak: '#B71C1C',
    doshaPresent: '#B71C1C',
    doshaAbsent: '#2E7D32',
  },
};

/** List of available scheme keys for the UI selector. */
export const schemeOptions = [
  { key: 'light', label: 'Light', labelTa: 'வெள்ளை' },
  { key: 'dark', label: 'Dark', labelTa: 'இருண்ட' },
  { key: 'saffron', label: 'Saffron', labelTa: 'குங்குமம்' },
];
